import React from 'react';
import './phonePreview.scss';
import phoneFrame from '../../assets/images/frame.png';
import placeholderImage from '../../assets/images/placeholder.png';
import { PhonePreviewProps } from './types';
import { IconChevronLeft } from '../Elements/CustomSVGIcon';

const PhonePreview: React.FC<PhonePreviewProps> = ({
    title,
    content,
    link,
    linkLabel,
    imageUrl,
}) => {
    const hasContent = imageUrl || title || content || (link && linkLabel);

    return (
        <div className="phone-preview">
            <div
                className="phone-frame"
                style={{
                    backgroundImage: `url(${phoneFrame})`,
                }}>
                <div className="screen-content">
                    {hasContent ? (
                        <>
                            <div className="preview-header">
                                <div className="preview-back-button">
                                    <IconChevronLeft />
                                </div>
                                <div className="preview-header-title">
                                    {title || 'Article Title'}
                                </div>
                            </div>
                            <div className="preview-image-container">
                                <img src={imageUrl || placeholderImage} className="preview-image" alt="upload preview" />
                            </div>
                            <div className="preview-content-container">
                                {content && <p className="preview-content">{content}</p>}
                                {link && linkLabel && (
                                    <a href={link} className="preview-link" target="_blank" rel="noopener noreferrer">
                                        {linkLabel}
                                    </a>
                                )}
                            </div>
                        </>
                    ) : (
                        <div className="empty-preview-message">
                            Enter content on the left to begin seeing a live preview
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PhonePreview;
